"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLedsService = exports.useLedsServiceClient = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function useLedsServiceClient() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.ledsServiceClientKey);
}
exports.useLedsServiceClient = useLedsServiceClient;
function useLedsService() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.ledsServiceKey);
}
exports.useLedsService = useLedsService;
//# sourceMappingURL=use-api.js.map